export default {"src":"/_next/static/media/renters-dashboard.b573639c.svg","height":27,"width":27};